<script>
    // ══════════════════════════════════════════════════════════════════════
    // ПАНЕЛЬ ЗАДАЧ КВЕСТА — справа сверху, стиль LC (тёмная панель + золото).
    // Сервер шлёт весь список; панель сама показывает ОКНО из трёх пунктов
    // вокруг текущего: выполненные уезжают вверх, новые приезжают снизу —
    // чтобы было ощущение прогресса, а не «куча задач сразу».
    //
    // Формат: window.lsTasksHud('{"title":"…","items":[{"t":"…","d":1}],"hint":"…"}')
    // d=1 — задача закрыта. null/пусто — панель скрыть.
    // ══════════════════════════════════════════════════════════════════════
    import { onDestroy } from 'svelte';
    import { lsTasksActive } from 'store/lsquest';
    // звук закрытия пункта отбивает КЛИЕНТ штатным звуковым API мода —
    // здесь его нет специально, иначе играл бы дважды и мимо настроек громкости

    let quest = null;        // {title, items, hint}
    let doneCount = 0;
    let shown = [];          // окно из трёх пунктов
    let lastDone = -1;       // сколько было закрыто в прошлом снимке
    let flash = -1;          // индекс пункта, который сейчас «загорается» галочкой
    let flashTimer = null;

    const WINDOW = 3;

    const rebuild = () => {
        if (!quest || !quest.items || !quest.items.length) { shown = []; return; }
        const items = quest.items;
        doneCount = items.filter((i) => i.d).length;
        // окно начинается с текущей задачи, но одну закрытую оставляем сверху —
        // видно, что только что засчиталось
        const cur = items.findIndex((i) => !i.d);
        const first = cur < 0 ? Math.max(0, items.length - WINDOW) : Math.max(0, cur - 1);
        shown = items.slice(first, first + WINDOW).map((it, k) => ({ ...it, i: first + k }));
    };

    window.lsTasksHud = (json) => {
        try {
            const next = json ? (typeof json === 'string' ? JSON.parse(json) : json) : null;
            if (!next) {
                quest = null; shown = []; lastDone = -1;
                lsTasksActive.set(false);
                return;
            }
            lsTasksActive.set(true);
            const wasSameQuest = quest && quest.title === next.title;
            const prevDone = wasSameQuest ? lastDone : -1;
            quest = next;
            rebuild();

            if (prevDone >= 0 && doneCount > prevDone) {
                // подсветить пункт, который только что закрылся
                flash = quest.items.reduce((acc, it, idx) => (it.d ? idx : acc), -1);
                try { clearTimeout(flashTimer); } catch (e) {}
                flashTimer = setTimeout(() => { flash = -1; }, 1400);
            }
            lastDone = doneCount;
        } catch (e) { quest = null; shown = []; lsTasksActive.set(false); }
    };

    onDestroy(() => { try { clearTimeout(flashTimer); } catch (e) {} });
</script>

{#if quest && shown.length}
<div class="lt">
    <div class="lt__head">
        <span class="lt__kick">Задание</span>
        <span class="lt__n">{doneCount}<em>/{quest.items.length}</em></span>
    </div>
    <div class="lt__title">{quest.title}</div>
    <div class="lt__bar"><i style="width:{Math.round((doneCount / quest.items.length) * 100)}%"></i></div>

    <div class="lt__list">
        {#each shown as it (it.i)}
            <div class="lt__row" class:done={it.d} class:cur={!it.d && it.i === shown.find((s) => !s.d)?.i} class:flash={it.i === flash}>
                <span class="lt__mark">
                    {#if it.d}
                        <svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5" /></svg>
                    {:else}
                        <i class="lt__dot"></i>
                    {/if}
                </span>
                <span class="lt__txt">{it.t}</span>
            </div>
        {/each}
    </div>

    {#if quest.hint}<div class="lt__hint">{quest.hint}</div>{/if}
</div>
{/if}

<style>
    .lt {
        /* ниже блока денег и времени в правом верхнем углу — иначе панель на него наезжает */
        position: fixed; right: 2.2vh; top: 13.8vh; z-index: 46; width: 30vh;
        padding: 1.5vh 1.8vh 1.5vh; border-radius: 1.2vh;
        background: rgba(20, 20, 22, .9);
        font-family: 'Manrope', 'Gilroy', sans-serif; color: #F2F0EB;
        pointer-events: none;
        animation: ltIn .28s cubic-bezier(.22,.61,.36,1) both;
    }
    @keyframes ltIn { from { opacity: 0; transform: translateX(1.6vh); } to { opacity: 1; transform: none; } }

    .lt__head { display: flex; align-items: baseline; justify-content: space-between; }
    .lt__kick {
        font-size: 1.02vh; font-weight: 600; letter-spacing: .16vh;
        text-transform: uppercase; color: rgba(242,240,235,.45);
    }
    .lt__n { font-size: 1.35vh; font-weight: 700; color: #E7AE3F; }
    .lt__n em { font-style: normal; font-weight: 500; color: rgba(242,240,235,.4); }

    .lt__title { margin-top: .35vh; font-size: 1.55vh; font-weight: 700; line-height: 1.2; }

    .lt__bar {
        margin: .9vh 0 1vh; height: .32vh; border-radius: .32vh;
        background: rgba(255,255,255,.09); overflow: hidden;
    }
    .lt__bar i { display: block; height: 100%; background: #E7AE3F; transition: width .35s ease; }

    .lt__list { display: flex; flex-direction: column; gap: .75vh; }
    .lt__row {
        display: flex; align-items: flex-start; gap: .85vh;
        animation: ltRow .3s ease both;
    }
    @keyframes ltRow { from { opacity: 0; transform: translateY(.8vh); } to { opacity: 1; transform: none; } }

    .lt__mark {
        flex: 0 0 auto; width: 1.7vh; height: 1.7vh; margin-top: .1vh;
        display: flex; align-items: center; justify-content: center;
    }
    .lt__dot {
        width: .7vh; height: .7vh; border-radius: 50%;
        border: .16vh solid rgba(242,240,235,.35);
    }
    .lt__row.cur .lt__dot { border-color: #E7AE3F; box-shadow: 0 0 0 .3vh rgba(231,174,63,.16); }
    .lt__mark svg { width: 100%; height: 100%; fill: none; stroke: #6CC28A; stroke-width: 2.6; stroke-linecap: round; stroke-linejoin: round; }

    .lt__txt { font-size: 1.3vh; font-weight: 500; line-height: 1.3; color: rgba(242,240,235,.62); }
    .lt__row.cur .lt__txt { color: #F2F0EB; font-weight: 600; }
    .lt__row.done .lt__txt { color: rgba(242,240,235,.32); text-decoration: line-through; }

    .lt__row.flash { animation: ltFlash .9s ease both; }
    @keyframes ltFlash {
        0% { transform: scale(1); }
        22% { transform: scale(1.035); }
        100% { transform: scale(1); }
    }

    .lt__hint {
        margin-top: 1.1vh; padding-top: .9vh; border-top: .09vh solid rgba(255,255,255,.08);
        font-size: 1.15vh; font-weight: 500; line-height: 1.35; color: rgba(242,240,235,.5);
    }
</style>
